import {
  Conversation,
  ConversationLogItemParticipantLeft,
} from '@stripe-internal/conversations-client';
import {view} from '@sail/ui/deprecated';
import {LeaveRow} from '../../Chat/Row/LeaveRow';

export const ParticipantLeftRow = ({
  conversation,
  item,
}: {
  conversation: Conversation;
  item: ConversationLogItemParticipantLeft;
}) => {
  if (item.participant.id === conversation.user.id) {
    return null;
  }

  return (
    <view.div
      className="uh-conversations-contains-meta-row"
      data-testid="conversation-log-participant-left"
    >
      <LeaveRow name={item.participant.displayName} />
    </view.div>
  );
};
